import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext.jsx';

/**
 * Renders children only for a signed-in user, optionally limited to `roles`.
 * The server enforces the same rules; this guard only shapes the experience.
 */
const RequireAuth = ({ roles, children }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (roles && !roles.includes(user?.role)) {
    return <Navigate to="/dashboard" replace state={{ reason: 'forbidden' }} />;
  }

  return children;
};

export default RequireAuth;
